import client from '../utils/client';
import { gatewaysUrl } from '../store/constants/api';
import { cookieConstants } from '../store/constants';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

export const gatewayService = {
  gatewaysList,
  addGateway,
  getGateway,
  updateGateway,
};

function gatewaysList(pageID, perPage) {
  return client
    .get(gatewaysUrl + '?page=' + pageID + '&per_page=' + perPage)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function addGateway(formDate) {
  return client
    .post(gatewaysUrl + '/create', formDate)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function getGateway(gatewayID) {
  return client
    .get(gatewaysUrl + '/' + gatewayID + '/show')
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function updateGateway(formDate) {
  return client
    .post(gatewaysUrl + '/update', formDate)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: '/' });
  cookies.remove(cookieConstants.USER, { path: '/' });
}

function handleResponse(response) {
  response = response.response;
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}
